

import "./DropDownmenu.css";
import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";


const DropDownmenu = (props) => {
  const { items, closeMenu } = props;
  const location = useLocation(); 

  const isRouteActive = (link) => {
    return link === location.pathname;
  };

  const handleLinkClick = (link) => {
    closeMenu(); 
    // window.location.href = link;
  };
  return (
    <div className="dropdown_menu">
      <ul>
        {items.map((item, index) => (
          <li key={index}>
            <Link
            to={(item.link)}
              className={`dropdown_link ${isRouteActive(item.link) ? 'active1' : ''}`}
              onClick={() => handleLinkClick(item.link)}
            >
              {item.text}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default DropDownmenu;



